import { EvadocInfoDto } from "./evadoc-info-dto";
import { PersonaDto } from "./persona-dto";

export class ParesDto {
    evaluado: EvadocInfoDto;
    evaluador: PersonaDto;
    validarEvaluacion: boolean;
}
